import { GameState } from "../Game"

const initializeContext = (context: GameState) => {
	const { dispatch, provider } = context

	// TODO: Connect to metamask/alt provider if user was previously logged in
	// Use localStorage for this?
}

export default initializeContext
